import { render, staticRenderFns } from "./zzjiagou.vue?vue&type=template&id=513b35d3&scoped=true&"
import script from "./zzjiagou.vue?vue&type=script&lang=js&"
export * from "./zzjiagou.vue?vue&type=script&lang=js&"
import style0 from "./zzjiagou.vue?vue&type=style&index=0&id=513b35d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b35d3",
  null
  
)

export default component.exports